import { SVGProps } from 'react';

export default function InventoryQuantityIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
      <g clipPath="url(#clip0_7668_17762)">
        <path
          d="M5.71875 10.7197H10.0938C11.3019 10.7197 12.2812 9.74028 12.2812 8.53218V4.15718C12.2812 2.94908 11.3019 1.96968 10.0938 1.96968H5.71875C4.51065 1.96968 3.53125 2.94908 3.53125 4.15718V8.53218C3.53125 9.74028 4.51065 10.7197 5.71875 10.7197ZM5.71875 10.7197H3.53125C2.32315 10.7197 1.34375 11.6991 1.34375 12.9072M7.90625 1.96968V4.15718M15.844 10.7197H24.9688C26.1769 10.7197 27.1562 11.6991 27.1562 12.9072M18.4062 23.8447C17.1981 23.8447 16.2188 22.8653 16.2188 21.6572V17.2822C16.2188 16.0741 17.1981 15.0947 18.4062 15.0947H22.7812C23.9894 15.0947 24.9688 16.0741 24.9688 17.2822V21.6572C24.9688 22.8653 23.9894 23.8447 22.7812 23.8447M20.5938 15.0947V17.2822M1.34375 26.0322C1.34375 24.8241 2.32315 23.8447 3.53125 23.8447H24.9688C26.1769 23.8447 27.1562 24.8241 27.1562 26.0322M5.71727 15.0933L10.0938 19.4697M5.71727 19.4697L10.0938 15.0947M18.4048 1.96826L22.7812 6.34468M18.4048 6.34468L22.7812 1.96968"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7668_17762">
          <rect width="28" height="28" fill="white" transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>
  );
}
